module.exports = __webpack_public_path__ + "img/badge-fastest-conversion-keyvue-pink.aba6d4e5.png";